import vars from "../helpers";

let isLoadedImages = false;

function init(container) {
	let $preloader = container.querySelector('.preloader');
	let $numperPercent = container.querySelector('.preloader__percent span');
	let imagesID = [20, 21, 22];

	if(!isLoadedImages) {
		let images = [];
		let device = 'desktop';

		if (vars.isMobile()) {
			device = 'mobile';
		}

		imagesID.forEach(element => {
			images.push(`${data.baseDir}images/pages/articles/${element}/cover-${device}.webp`);
		})

		// for (let i = 1; i <= data.families.length; i++) {
		// 	images.push(`${data.baseDir}images/pages/articles/${i}/cover-${device}.webp`);
		// }

		let imageCount = 0;
		let allImages = Math.floor(images.length);

		let oneImagePercent = 100 / allImages;

		for (let i = 0; i < images.length; i++) {
			let img = new Image();
			img.onload = function () {
				imageCount++;
				if (allImages >= imageCount) {
					let percent = Math.floor(oneImagePercent * imageCount);
					$($numperPercent).text(percent);
				}

				if (imageCount === allImages) {

					setTimeout(function () {
						$('body').addClass('is-loaded-preloader');
						isLoadedImages = true;
					}, 1000);

					setTimeout(function () {
						$($preloader).remove();
					}, 4000)
				}
			}
			img.src = images[i];
		}
	} else {
		$($preloader).remove();
	}
}

export default {
	init
}
